import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";

export const TaskPreviewDefaultCell = memo(function TaskPreviewDefaultCell({
    row,
    getValue,
}: {
    row: { original: { isGroupRow?: boolean } };
    getValue: () => unknown;
}) {
    if (row.original.isGroupRow) {
        return null;
    }
    return (
        <ViewTableCell>
            <span>{String(getValue() ?? "")}</span>
        </ViewTableCell>
    );
});
